<template>
  <v-container  justify="center">
    <v-layout justify-center>
      <v-dialog v-model="erroreConnessione" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">ERRORE CONNESSIONE</v-card-title>
          <v-card-text>Si è verificato un errore durante la comunicazione dei dati al server.</v-card-text>
          <v-card-text>Si prega di riprovare. Se l'errore persiste, contattare l'assistenza</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="#4EABDD" text @click="erroreConnessione = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="duplicato" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">ATTENZIONE</v-card-title>
          <v-card-text>Gentile utente, stai per inserire in un rubrica un contatto che ci risulta essere già presente con la stessa ragione sociale - indirizzo - località - cap e provincia (o identificativo, se previsto). </v-card-text>
          <v-card-text>Sei sicuro di voler procedere?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="#4EABDD" text @click="InserisciNuovo()">AGGIUNGI</v-btn>
            <v-btn flat color="#4EABDD" text @click="duplicato = false">ANNULLA</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="erroreValidazione" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">ERRORE</v-card-title>
          <v-card-text>Gentile utente, si sono verificati degli errori durante la validazione dei dati inseriti:</v-card-text>
          <v-card-text v-html="Errore">{{ Errore }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="#4EABDD" text @click="erroreValidazione = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="DialogErroreOrarioMAM" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">ERRORE INSERIMENTO ORARIO DI CHIUSURA MATTINA</v-card-title>
          <v-card-text v-html="ErroreOrario"></v-card-text>
          <v-card-text v-html="ErroreOrarioMattino"></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="#4EABDD" text @click="DialogErroreOrarioMAM = false; DialogErroreOrario = false; DialogErroreOrarioPDP = false; DialogErroreOrarioPAP = false; $refs.mamText.focus()">CHIUDI</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="DialogErroreOrarioPDP" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">ERRORE INSERIMENTO ORARIO DI APERTURA POMERIGGIO</v-card-title>
          <v-card-text v-html="ErroreOrario"></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="#4EABDD" text @click="DialogErroreOrarioMAM = false; DialogErroreOrario = false; DialogErroreOrarioPDP = false; DialogErroreOrarioPAP = false; $refs.pdpText.focus()">CHIUDI</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="DialogErroreOrarioPAP" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">ERRORE INSERIMENTO ORARIO DI CHIUSURA POMERIGGIO</v-card-title>
          <v-card-text v-html="ErroreOrario"></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="#4EABDD" text @click="DialogErroreOrarioMAM = false; DialogErroreOrario = false; DialogErroreOrarioPDP = false; DialogErroreOrarioPAP = false; $refs.papText.focus()">CHIUDI</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-model="DialogErroreOrario" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">ERRORE INSERIMENTO ORARIO DI APERTURA MATTINO</v-card-title>
          <v-card-text v-html="ErroreOrario"></v-card-text>
          <v-card-text v-html="ErroreOrarioMattino"></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="#4EABDD" text @click="DialogErroreOrarioMAM = false; DialogErroreOrario = false; DialogErroreOrarioPDP = false; DialogErroreOrarioPAP = false; $refs.mdmText.focus()">CHIUDI</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center>
      <v-dialog v-if="Cappario" v-model="Cappario" persistent max-width="1400">
        <v-card>
          <v-container>
            <v-text-field
              label=""
              single-line
              hide-details
              readonly
              v-model="searchCappario"
            ></v-text-field>

            <v-data-table
              lazy
              v-bind:headers="headersCappario"
              v-bind:items="lista_cappario"
              v-bind:search="searchCappario"
            >
              <template slot="items" slot-scope="props">
                <tr
                  @click="SelezionaCapparioRitiro(props.item.trploc, props.item.trpprv, props.item.trpcap)"
                >
                  <td class="text-xs-left">{{ props.item.trploc }}</td>
                  <td class="text-xs-left">{{ props.item.trpprv }}</td>
                  <td class="text-xs-left">{{ props.item.trpcap }}</td>
                </tr>
              </template>
              <template
                slot="pageText"
                slot-scope="{ pageStart, pageStop }"
              >From {{ pageStart }} to {{ pageStop }}</template>
            </v-data-table>
            <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" text @click="ChiudiCappario">CHIUDI SENZA SELEZIONARE</v-btn>
          </v-container>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-sheet class="d-flex"  >
        <v-form v-model="valid" ref="form" >
          <v-container>
          <v-layout row wrap>
            <v-flex xs12 md12 d-flex >
              <v-text-field v-if="perIdentificativo == '1' || perIdentificativo == 1" label="Identificativo" maxlength = "7" v-model="identificativo" outline :background-color="identificativoColore"></v-text-field>
            </v-flex>
            <v-flex xs12 md6 d-flex >
              <v-text-field :label="$t('key006')" v-model="ragioneSociale" maxlength="40" outline :background-color="ragioneSocialeColore"></v-text-field>
            </v-flex>
            <v-flex xs12 md6 d-flex >
            <v-text-field :label="$t('key007')" v-model="indirizzo" required maxlength="40" outline :background-color="indirizzoColore"></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-select
                :items="nazioni"
                v-model="nazione"
                :label="$t('key375')"
                @change="nazione_selezionata = nazione.value"
                outline
              ></v-select>
            </v-flex>
            <v-flex xs12 md3 d-flex >
              <v-text-field 
              :label="$t('key008')"
              v-model="comune"
              maxlength="30"
              @blur="(!ProvinciaValida || provincia === '') ?OpenCappario(comune):CambioFocusLocalita()"
              outline
              :background-color="comuneColore"></v-text-field>
            </v-flex>
            <v-flex xs12 md3 d-flex >
              <v-text-field
                ref="cap"
               :label="$t('key009')"
               v-model="cap"
               required
               maxlength="11"
               @blur="(provincia === '' || !ProvinciaValida) ? OpenCappario(cap) : CambioFocusCap()"
               outline
               :background-color="capColore"></v-text-field>
            </v-flex>
            <v-flex xs12 md3 d-flex >
              <v-text-field
                ref="provincia"
               :label="$t('key010')"
               v-model="provincia"
               required
               maxlength="2"
               @blur="Valida_Localita()"
               outline
               :background-color="provinciaColore"></v-text-field>
            </v-flex>
            <v-flex xs12 sm3>
            </v-flex>
            <v-flex xs12 sm9>
              <h4 style="color: red;" v-if="!ProvinciaValida">Attenzione: Località, cap e provincia non corrispondono.</h4>
            </v-flex>
            <v-flex xs12 md4 d-flex>
              <v-text-field ref="riferimento1" label="Referente" v-model="referente" required outline :background-color="referente1Colore"></v-text-field>
            </v-flex>
            <v-flex xs12 md4 d-flex>
              <v-text-field :label="$t('key015')" v-model="telefono"  maxlength = "15" required outline :background-color="telefono1Colore" @keypress="isIntegerTelefono($event)"></v-text-field>
            </v-flex>
            <v-flex xs12 md4 d-flex>
              <v-text-field label="Email" v-model="email" required maxlength="250" outline :rules="[v=> ValidaEmail(v) || 'email non valida']" :background-color="email1Colore"></v-text-field>
            </v-flex>

            <v-flex xs12 md4 d-flex>
              <v-text-field label="Referente 2" v-model="referente2" required outline :background-color="referente2Colore"></v-text-field>          
            </v-flex>
            <v-flex xs12 md4 d-flex>
              <v-text-field :label="$t('key015')" v-model="telefono2" maxlength = "15" required outline :background-color="telefono2Colore" @keypress="isIntegerTelefono($event)"></v-text-field>
            </v-flex>
            <v-flex xs12 md4 d-flex>
              <v-text-field label="Email" v-model="email2" required maxlength="250" outline :rules="[v=> ValidaEmail(v) || 'email non valida']" :background-color="email2Colore"></v-text-field>
            </v-flex>
            <v-flex xs6 md2 d-flex>
              <v-text-field :label="$t('key016')" ref="mdmText" v-model="MDM" required outline @keypress="isIntegerDate($event)" @blur="CheckMDM" :background-color="MDMColore"> </v-text-field>
            </v-flex>
            <v-flex xs6 md2 d-flex>
              <v-text-field :label="$t('key017')" ref="mamText" v-model="MAM" required outline @keypress="isIntegerDate($event)" @blur="CheckMAM" :background-color="MAMColore"></v-text-field>
            </v-flex>
            <v-flex xs6 md2 d-flex>
              <v-text-field :label="$t('key018')" ref="pdpText" v-model="PDP" required outline @keypress="isIntegerDate($event)" @blur="CheckPDP" @focus="CheckMattino" :background-color="PDPColore"></v-text-field>
            </v-flex>
            <v-flex xs6 md2 d-flex>
              <v-text-field :label="$t('key019')" ref="papText" v-model="PAP" required outline @keypress="isIntegerDate($event)" @blur="CheckPAP" :background-color="PAPColore"></v-text-field>
            </v-flex>
          <v-flex xs12 md12>
            <h1>{{$t('key020')}}</h1>
          </v-flex>
          <v-layout :wrap="true" d-flex>
          <v-flex xs12 md4 d-flex>
          <v-radio-group v-model="lunedi" row>
          <h3>{{$t('key021')}}: </h3>
          <v-spacer></v-spacer>
          <v-radio
            v-for="n in 4"
            :key="n"
            :label="Radio[n-1]"
            :value="n"
          ></v-radio>
      </v-radio-group>
            
      <v-radio-group v-model="martedi" row>
          <h3>{{$t('key022')}}: </h3>
          <v-spacer></v-spacer>
          <v-radio
            v-for="n in 4"
            :key="n"
            :label="Radio[n-1]"
            :value="n"
          ></v-radio>
      </v-radio-group>
      
      <v-radio-group v-model="mercoledi" row>
          <h3>{{$t('key023')}}: </h3>
          <v-spacer></v-spacer>
          <v-radio
            v-for="n in 4"
            :key="n"
            :label="Radio[n-1]"
            :value="n"
          ></v-radio>
      </v-radio-group>
      
          <v-radio-group v-model="giovedi" row>
          <h3>{{$t('key024')}}: </h3>
              <v-spacer></v-spacer>
              <v-radio
                v-for="n in 4"
                :key="n"
                :label="Radio[n-1]"
                :value="n"
              ></v-radio>
            </v-radio-group>
          
              <v-radio-group v-model="venerdi" row>
          <h3>{{$t('key025')}}: </h3>
                  <v-spacer></v-spacer>
                  <v-radio
                    v-for="n in 4"
                    :key="n"
                    :label="Radio[n-1]"
                    :value="n"
                  ></v-radio>
              </v-radio-group>
          
        </v-flex>
          </v-layout>
          
          <v-flex xs12 md6 d-flex>
          <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" @click="NormalizzaCampi" :disabled="!valid">CONFERMA</v-btn>
          <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" @click="clear">{{ $t('key331') }}</v-btn>
          </v-flex>
          </v-layout>
          </v-container>
        </v-form>
      
      </v-sheet>

  </v-container>
  
</template>


<script>
import axios from "axios";

export default {
  data: () => ({
    perIdentificativo: 0,
    erroreConnessione: false,
    identificativoColore: "",
    ragioneSocialeColore : "",
    indirizzoColore: "",
    comuneColore: "",
    capColore: "",
    provinciaColore : "",
    referente1Colore: "",
    telefono1Colore: "",
    email1Colore: "",
    referente2Colore: "",
    telefono2Colore: "",
    email2Colore: "",
    MDMColore: "",
    MAMColore: "",
    PDPColore: "",
    PAPColore: "",
    duplicato: false,
    erroreValidazione: false,
    Errore: "",
    valid: true,
    ErroreOrario: "",
    ErroreOrarioMattino: "",
    DialogErroreOrario: false,
    DialogErroreOrarioMAM: false,
    DialogErroreOrarioPAP: false,
    DialogErroreOrarioPDP: false,
    ProvinciaValida: true,
    nazioni: [],
    nazione: {value: "I"},
    nazione_selezionata: "I",
    Radio_it: ["Mai", "Mattina", "Pomeriggio", "Tutto il giorno"],
    Radio_en: ["Never", "Morning", "Afternoon", "All day"],
    Radio: [],
    lunedi: 1,
    martedi: 1,
    mercoledi: 1,
    giovedi: 1,
    venerdi: 1,
    clientId: "",
    referente2: "",
    email2: "",
    telefono2: "",
    identificativo: "",
    ragioneSociale: "",
    indirizzo: "",
    cap: "",
    comune: "",
    provincia: "",
    referente: "",
    email: "",
    telefono: "",
    MDM: "08:00",
    MAM: "13:00",
    PDP: "13:30",
    PAP: "18:00",
    giorniAperturaSettimanali: "",
    Civico: "",
    update: false,
    Cappario: false,
    searchCappario: "",
    overlay: false,
    lista_cappario: [],
    headersCappario: [
      { text: "Località", align: "left", value: "trploc" },
      { text: "Provincia", align: "left", value: "trpprv" },
      { text: "CAP", align: "left", value: "trpcap" }
    ],
    json: {},
    status: 0,

  }),
  created(){
    this.$store.dispatch("ImpostaScollegamento");
  },
  mounted() {
    if(this.$i18n.locale=='it') {
      this.Radio = this.Radio_it;
    } else {
      this.Radio = this.Radio_en;
    }
    this.CheckJWT();
    this.id = this.$route.params.id;
    this.codiceAzienda = this.$route.params.codiceAzienda;

    if (this.id !== 0 && this.id !== "0") {
      this.getDataForId();
      this.update = true;
    }
    
  },
   created() {
    this.$store.dispatch("ImpostaScollegamento");
    this.GetNazioni();
    this.CheckPermessoIdentificativo();
    
  },
  methods: {
    isIntegerTelefono(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 43) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    CheckPermessoIdentificativo(){
      axios.get(this.$store.state.servicePath + "/api/ArUtentiPermessis/Check/VIS-IDCLI").
      then(res=>{
        this.perIdentificativo = res.data;
      })
    },
    ChiudiCappario() {
      this.$refs.cap.focus();
      this.Cappario = false;
      this.searchCappario = "";
    },
    Validate(){
      this.Errore = "";
      if((this.perIdentificativo === 1 || this.perIdentificativo === "1") && this.identificativo.trim() == ""){
        this.Errore += "- E' obbligatorio inserire un identificativo per il contatto <br>";
        this.identificativoColore = "red";
      }
      if(this.ragioneSociale.trim().length === 0){
        this.Errore += "- E' obbligatorio inserire una ragione sociale <br>";
        this.ragioneSocialeColore = "red";
      }
      else if(this.ragioneSociale.trim().length < 5){
        this.Errore += "- La ragione sociale deve essere lunga almeno 5 caratteri <br>";
        this.ragioneSocialeColore = "red";
      }
      var patt = /[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]+[0-9]/g;
      var result_rags = this.ragioneSociale.match(patt);
      var result_ind = this.indirizzo.match(patt);
      if(result_rags != null){
        this.Errore += " - Non è possibile inserire un numero telefonico all'interno della ragione sociale</br>";
        this.ragioneSocialeColore = "red";
      }
      if(result_ind != null){
        this.Errore += " - Non è possibile inserire un numero telefonico all'interno dell' indirizzo</br>";
        this.indirizzoColore = "red";
      }
      if(this.indirizzo.trim().length === 0){
        this.Errore += "- E' obbligatorio inserire un indirizzo <br>";
        this.indirizzoColore = "red";
      }
      else if(this.indirizzo.trim().length < 5){
        this.Errore += "- l'indirizzo deve essere lungo almeno 5 caratteri <br>";
        this.indirizzoColore = "red";
      }
      if(this.comune.trim().length === 0){
        this.Errore += "- E' obbligatorio inserire una località <br>";
        this.comuneColore = "red";
      }
      else if(this.comune.trim().length < 2){
        this.Errore += "- La località deve essere lunga almeno 2 caratteri <br>";
        this.comuneColore = "red";
      }
      if(this.cap.trim().length === 0){
        this.Errore += "- E' obbligatorio inserire un cap<br>";
        this.capColore = "red";
      }
      if(this.provincia.trim().length === 0){
        this.Errore += "- E' obbligatorio inserire una provincia<br>";
        this.provinciaColore = "red";
      }
      else if(this.provincia.trim().length < 2){
        this.Errore += "- La provincia deve essere lunga 2 caratteri <br>";
        this.provinciaColore = "red";
      }
      // controllo che nel telfono siano presenti almeno 6 caratteri numerici oltre ad un eventuale +
      var ErroreTelefono = false;
      var regexNum = /[0-99]/g;
      if(this.telefono.trim().length !== 0 && this.telefono.replace("+", "").trim().length < 6){
        this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri e iniziare per +, 3 o 0. </br>";
        this.telefono1Colore = "red";
        ErroreTelefono = true;
      }
      else{
        if(this.telefono.trim().length !== 0){
          var resultTelefono = this.telefono.match(regexNum);
          if(resultTelefono !== null){
            if(resultTelefono.length < 6){
              this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri e iniziare per +, 3 o 0. </br>";
              this.telefono1Colore = "red";
              ErroreTelefono = true;
            }
          }
          else{
            this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri e iniziare per +, 3 o 0. </br>";
            this.telefono1Colore = "red";
            ErroreTelefono = true;
          }
        }
      }
      if(!ErroreTelefono && this.telefono.trim().length !== 0){
        var regexNum = /[^0-99]/g;
        var resultTelefono = this.telefono.match(regexNum);
        //if(resultTelefono !== null){
          //////////////////////////////
        if(resultTelefono !== null){
          if(resultTelefono.length > 1){
            this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri e iniziare per +, 3 o 0. </br>";
            this.telefono1Colore = "red";
          }
          else {
            if(!this.telefono.startsWith("+")){
              this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri e iniziare per +, 3 o 0. </br>";
              this.telefono1Colore = "red";
            }
            else{
              if(!this.telefono.startsWith("3") && !this.telefono.startsWith("0") && !this.telefono.startsWith("+")){
                this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri e iniziare per +, 3 o 0. </br>";
              this.telefono1Colore = "red";
              }
           }
          }
        
        }
        else{
              if(!this.telefono.startsWith("3") && !this.telefono.startsWith("0") && !this.telefono.startsWith("+")){
                this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri e iniziare per +, 3 o 0. </br>";
              this.telefono1Colore = "red";
              }
        }
      }
          //////////////////////////////
      //     if(resultTelefono.length > 1){
      //       this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri e iniziare per +, 3 o 0. </br>";
      //       this.telefono1Colore = "red";
      //     }
      //     else if(resultTelefono[0] === "+"){
      //       if(!this.telefono.startsWith("+")){
      //         this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri e iniziare per +, 3 o 0. </br>";
      //         this.telefono1Colore = "red";
      //       }
      //     }
      //     else{
      //       this.Errore += "- Il numero di telefono inserito deve contenere solo numeri e iniziare per +, 3 o 0. </br>";
      //         this.telefono1Colore = "red";
      //     }
      //   }
      //   else{
      //     if(!this.telefono.startsWith("3") && !this.telefono.startsWith("0")){
      //       this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri e iniziare per +, 3 o 0. </br>";
      //       this.telefono1Colore = "red";
      //     }
      //   }
      // }
      var ErroreTelefono2 = false;
      var regexNum = /[0-99]/g;
      if(this.telefono2.trim().length !== 0 && this.telefono2.replace("+", "").trim().length < 6){
        this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri.</br>";
        this.telefono2Colore = "red";
        ErroreTelefono2 = true;
      }
      else{
        if(this.telefono2.trim().length !== 0){
          var resultTelefono2 = this.telefono2.match(regexNum);
          if(resultTelefono2 !== null){
            if(resultTelefono2.length < 6){
              this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri.</br>";
              this.telefono2Colore = "red";
              ErroreTelefono2 = true;
            }
          }
          else{
            this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri.</br>";
            this.telefono2Colore = "red";
            ErroreTelefono2 = true;
          }
        }
      }
      if(!ErroreTelefono2 && this.telefono2.trim().length !== 0){
        var regexNum = /[^0-99]/g;
        var resultTelefono = this.telefono2.match(regexNum);
        if(resultTelefono !== null){
          if(resultTelefono.length > 1){
            this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri e iniziare per +, 3 o 0. </br>";
            this.telefono2Colore = "red";
          }
          else if(resultTelefono[0] === "+"){
            if(!this.telefono2.startsWith("+")){
              this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri e iniziare per +, 3 o 0. </br>";
              this.telefono2Colore = "red";
            }
          }
          else{
            this.Errore += "- Il numero di telefono inserito deve contenere solo numeri e iniziare per +, 3 o 0. </br>";
              this.telefono2Colore = "red";
          }
        }
        else{
          if(!this.telefono2.startsWith("3") && !this.telefono2.startsWith("0")){
            this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri e iniziare per +, 3 o 0. </br>";
            this.telefono2Colore = "red";
          }
        }
      }
      /*
      else{
          if(!this.telefono2.startsWith("3") && !this.telefono2.startsWith("0")){
            this.Errore += "- Il numero di telefono inserito deve contenere almeno 6 numeri e iniziare per +, 3 o 0. </br>";
            this.telefono2Colore = "red";
          }
        }
      */
      var regexEmail = /^(([^\'<>()\[\]\\.,;:\s@"]+(\.[^\'<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
      if(this.email.trim() !== ""){
        var resultMail = this.email.trim().match(regexEmail);
        if(resultMail === null){
          this.Errore += "- La mail per il contatto di riferimento non è valida </br>";
          this.email1Colore = "red";
        }
      }
      if(this.email2.trim() !== ""){
        var resultMail2 = this.email2.trim().match(regexEmail);
        if(resultMail2 === null){
          this.Errore += "- La mail per il contatto di riferimento non è valida </br>";
          this.email2Colore = "red";
        }
      }
      if(this.MDM === "00:00" && this.MAM === "00:00" && this.PDP === "00:00" && this.PAP === "00:00"){
        this.Errore += "- E' necessario specificare almeno una tra la fascia oraria di apertura del mattino e quella del pomeriggio <br>";
        this.MDMColore = "red";
        this.MAMColore = "red";
        this.PDPColore = "red";
        this.PAPColore = "red";
      }
      var regexNum = /[^0-99]/g;
          var resultMDM = this.MDM.replace(":", "").match(regexNum);
          var resultMAM = this.MAM.replace(":", "").match(regexNum);
          var resultPDP = this.PDP.replace(":", "").match(regexNum);
          var resultPAP = this.PAP.replace(":", "").match(regexNum);
      
          if(resultMDM != null){
            this.Errore += "- Non è possibile inserire caratteri non numerici nell'orario di apertura della mattina <br>"
            this.MDMColore = "red";
          }
          if(resultMAM != null){
            this.Errore += "- Non è possibile inserire caratteri non numerici nell'orario di chiusura della mattina <br>"
            this.MAMColore = "red";
          }
          if(resultPDP != null){
            this.Errore += "- Non è possibile inserire caratteri non numerici nell'orario di apertura del pomeriggio <br>"
            this.PDPColore = "red";
          }
          if(resultPAP != null){
            this.Errore += "- Non è possibile inserire caratteri non numerici nell'orario di chiusura del pomeriggio <br>"
            this.PAPColore = "red";
          }
      if(this.MDM.trim().length != 5 || this.MDM.trim().replaceAll(":", "").length != 4){
          this.Errore += "- Controllare il formato dell'orario dell'apertura della mattina inserito. Il formato deve seguire la regola: HH:MM. <br>";
          this.MDMColore = "red";
        }
        else if(this.MDM !== "00:00"){
          if(!this.MDM.includes(":")){
            this.Errore += "- Controllare il formato dell'orario dell'apertura della mattina inserito. Il formato deve seguire la regola: HH:MM. <br>";
            this.MDMColore = "red";
          }
          if(this.MDM[2] != ":"){
            this.Errore += "- Controllare il formato dell'orario dell'apertura della mattina inserito. Il formato deve seguire la regola: HH:MM. <br>";
            this.MDMColore = "red";
          }
          if(this.MAM !== "00:00" && this.MDM.substring(0,2) > this.MAM.substring(0,2)){
            this.Errore += "- Non è possibile indicare un orario successivo a quello di chiusura della mattina.<br>";
            this.MDMColore = "red";
          }
          if(Number(this.MDM.substring(0,2)) > 13 || (Number(this.MDM.substring(0,2)) === 13 && Number(this.MDM.substring(3,5)) > 0)){
            this.Errore += "- Non è possibile indicare un orario successivo alle 13:00.<br>";
            this.MDMColore = "red";
          }
          if(Number(this.MDM.substring(0,2)) < 6 || (Number(this.MDM.substring(0,2)) === 6 && Number(this.MDM.substring(3,5)) < 30)){
            this.Errore += "- Non è possibile indicare un orario precedente alle 06:30.<br>";
            this.MDMColore = "red";
          }
          if((this.MAM !== "00:00") && (this.MDM.substring(0,2) == this.MAM.substring(0,2) && Number(this.MDM.substring(3,5)) > Number(this.MAM.substring(3,5)))){
            this.Errore += "- Non è possibile indicare un orario successivo a quello di chiusura della mattina.<br>";
            this.MDMColore = "red";
          }
          if(this.MDM == this.MAM){
            this.Errore += "- Non è possibile indicare un orario uguale a quello di chiusura della mattina.<br>";
            this.MDMColore = "red";
          }
          if(Number(this.MDM.substring(3,5)) > 59 ){
            this.Errore += "- Controllare il formato dell'orario dell'apertura della mattina inserito. Il formato deve seguire la regola: HH:MM.";
            this.MDMColore = "red";
          }
        }
        if(this.MAM.trim().length != 5 || this.MAM.trim().replaceAll(":", "").length != 4){
          this.Errore += "- Controllare il formato dell'orario della  chiusura della mattina inserito. Il formato deve seguire la regola: HH:MM. <br>";
          this.MAMColore = "red";
        }
        else if (this.MAM !== "00:00"){
          if(!this.MAM.includes(":")){
            this.Errore += "- Controllare il formato dell'orario della  chiusura della mattina inserito. Il formato deve seguire la regola: HH:MM. <br>";
            this.MAMColore = "red";
            }
          if(Number(this.MAM.substring(0,2)) > 13 || (Number(this.MAM.substring(0,2)) === 13 && Number(this.MAM.substring(3,5)) > 0)){
            this.Errore += "- Non è possibile indicare un orario successivo alle 13:00.<br>";
            this.MAMColore = "red";
          }
          if(Number(this.MDM.substring(0,2)) < 6 || (Number(this.MDM.substring(0,2)) === 6 && Number(this.MDM.substring(3,5)) < 30)){
            this.Errore += "- Non è possibile indicare un orario precedente alle 06:30.<br>";
            this.MAMColore = "red";
          }
          if(this.MDM !== "00:00" && this.MDM.substring(0,2) > this.MAM.substring(0,2)){
            this.Errore += "- Non è possibile indicare un orario precedente a quello di apertura della mattina.<br>";
            this.MAMColore = "red";
          }
          if(this.MDM !== "00:00" && (this.MDM.substring(0,2) == this.MAM.substring(0,2) && Number(this.MDM.substring(3,5)) > Number(this.MAM.substring(3,5)))){
            this.Errore += "- Non è possibile indicare un orario precedente a quello di apertura della mattina.<br>";
            this.MAMColore = "red";
          }
          if(this.MDM == this.MAM){
            this.Errore += "- Non è possibile indicare un orario uguale a quello di apertura della mattina.<br>";
            this.MAMColore = "red";
            }
          if(Number(this.MAM.substring(3,5)) > 59 ){
            this.Errore += "- Controllare il formato dell'orario della chiusura della mattina inserito. Il formato deve seguire la regola: HH:MM.";
            this.MAMColore = "red";
          }
        }

        if(this.PDP.trim().length != 5 || this.PDP.trim().replaceAll(":", "").length != 4){
          this.Errore += "- Controllare il formato dell'orario di apertura del pomeriggio inserito. Il formato deve seguire la regola: HH:MM. <br>";
          this.PDPColore = "red";
        }
        else if (this.PDP !== "00:00"){
          if(!this.PDP.includes(":")){
            this.Errore += "- Controllare il formato dell'orario dell'apertura' del pomeriggio inserito. Il formato deve seguire la regola: HH:MM. <br>";
            this.PDPColore = "red";
          }
          if(Number(this.PDP.substring(0,2)) > 19 || (Number(this.PDP.substring(0,2)) === 19 && Number(this.PDP.substring(3,5)) > 30)){
            this.Errore += "- Non è possibile indicare un orario successivo alle 19:30.<br>";
            this.PDPColore = "red";
          }
          if(Number(this.PDP.substring(0,2)) < 13 || Number(this.PDP.substring(0,2)) === 13 && Number(this.PDP.substring(3,5)) < 1){
            this.Errore += "- Non è possibile indicare un orario precedente alle 13:01.<br>";
            this.PDPColore = "red";
          }
          if(this.PAP !== "00:00" && (this.PDP.substring(0,2) > this.PAP.substring(0,2))){
            this.Errore += "- Non è possibile indicare un orario successivo a quello di chiusura del pomeriggio.<br>";
            this.PDPColore = "red";
          }
          if(Number(this.PDP.substring(3,5)) > 59 ){
            this.Errore += "- Controllare il formato dell'orario della chiusura del pomeriggio inserito. Il formato deve seguire la regola: HH:MM.";
            this.PDPColore = "red";
          }
          if(this.PDP == this.PAP){
            this.Errore += "- Non è possibile indicare un orario uguale a quello di chiusura del pomeriggio.<br>";
            this.PDPColore = "red";
          }
          if(this.PAP !== "00:00" && (this.PDP.substring(0,2) == this.PAP.substring(0,2) && Number(this.PDP.substring(3,5)) > Number(this.PAP.substring(3,5)))){
            this.Errore += "- Non è possibile indicare un orario successivo a quello di chiusura del pomeriggio.<br>";
            this.PDPColore = "red";
          }
        }
        if(this.PAP.trim().length != 5 ||  this.PAP.trim().replaceAll(":", "").length != 4){
          this.Errore += "- Controllare il formato dell'orario della chiusura del pomeriggio inserito. Il formato deve seguire la regola: HH:MM. <br>";
          this.PAPColore = "red";
        }
        else if(this.PAP !== "00:00"){
          if(!this.PAP.includes(":")){
            this.Errore += "- Controllare il formato dell'orario della chiusura del pomeriggio inserito. Il formato deve seguire la regola: HH:MM. <br>";
            this.PAPColore = "red";
          }
          if(Number(this.PAP.substring(0,2)) > 19 || (Number(this.PAP.substring(0,2)) === 19 && Number(this.PAP.substring(3,5)) > 30)){
            this.Errore += "- Non è possibile indicare un orario successivo alle 19:30.<br>";
            this.PAPColore = "red";
          }
          if(Number(this.PAP.substring(0,2)) < 13 || Number(this.PAP.substring(0,2)) === 13 && Number(this.PAP.substring(3,5)) < 1){
            this.Errore += "- Non è possibile indicare un orario precedente alle 13:01.<br>";
            this.PAPColore = "red";
          }
          if(this.PAP !== "00:00" && (this.PDP.substring(0,2) == this.PAP.substring(0,2) && Number(this.PDP.substring(3,5)) > Number(this.PAP.substring(3,5)))){
            this.Errore += "- Non è possibile indicare un orario precedente a quello di apertura del pomeriggio.<br>";
            this.PAPColore = "red";
          }
          if(Number(this.PAP.substring(3,5)) > 59 ){
            this.Errore += "- Controllare il formato dell'orario della chiusura del pomeriggio inserito. Il formato deve seguire la regola: HH:MM.";
            this.PAPColore = "red";
          }
          if(this.PDP == this.PAP){
            this.Errore += "- Non è possibile indicare un orario uguale a quello di apertura del pomeriggio.<br>";
            this.PAPColore = "red";
          }
          if(this.PDP !== "00:00" && this.PDP.substring(0,2) > this.PAP.substring(0,2)){
            this.Errore += "- Non è possibile indicare un orario precedente a quello di apertura del pomeriggio.<br>";
            this.PAPColore = "red";
          }
        }
      if(this.MAM === "00:00" && this.MDM !== "00:00"){
        this.Errore += "- Il campo orario chiusura della mattina deve essere valorizzato se valorizzato l'orario di apertura.<br>";
        this.MAMColore = "red";
      }
      else{
        if(this.MAM !== "00:00" && this.MDM === "00:00" ){
          this.Errore += "- Il campo orario apertura della mattina deve essere valorizzato se valorizzato l'orario di chiusura.<br>";
          this.MDMColore = "red";
        }
      }
      if(this.PDP === "00:00"  && this.PAP !== "00:00"){
        this.Errore += "- Il campo orario apertura del pomeriggio deve essere valorizzato se valorizzato l'orario di chiusura.<br>";
        this.PDPColore = "red";
      }
      else{
        if(this.PDP !== "00:00" && this.PAP === "00:00" ){
          this.Errore += "- Il campo orario chiusura del pomeriggio deve essere valorizzato se valorizzato l'orario di apertura.<br>";
          this.PAPColore = "red";
        }
      }
      if (this.Errore !== "") {
        this.overlay = false;
        this.erroreValidazione = true;
      } else {
        if(this.MDM === "00:00" && this.MAM === "00:00"){
          if(this.lunedi != 4)
            this.lunedi = 2;
          if(this.martedi != 4)
            this.martedi = 2;
          if(this.mercoledi != 4)
            this.mercoledi = 2;
          if(this.giovedi != 4)
            this.giovedi = 2;
          if(this.venerdi)
            this.venerdi = 2;
        }
        else if(this.PDP === "00:00" && this.PAP === "00:00"){
          if(this.lunedi != 4)
            this.lunedi = 3;
          if(this.martedi != 4)
            this.martedi = 3;
          if(this.mercoledi != 4)
            this.mercoledi = 3;
          if(this.giovedi != 4)
            this.giovedi = 3;
          if(this.venerdi != 4)
            this.venerdi = 3;
        }
        this.Valida_Cappario();
      }
    },
    Valida_Cappario(){
      axios.get(this.$store.state.servicePath + "/api/ArVwNazionis/ValidaCappario/" + this.nazione_selezionata + "/" + this.comune + "/" + this.cap +"/" + this.provincia)
      .then(res => {
        if(res.data){
          this.submit();
        }
        else{
          this.Errore = "Non è stato possibile validare Località - Cap e provincia inseriti con il nostro cappario. Si prega di correggere i dati e riprovare";
          this.overlay = false;
          this.erroreValidazione = true;  
        }
      })
      .catch(err=>{
        this.Errore = "- Errore durante la validazione del cappario. Si prega di riprovare. Nel caso l'errore persista contattare l'assistenza";
        this.overlay = false;
        this.erroreValidazione = true;
      })
    },
    NormalizzaCampi(){
      //resetto i colori della validazione
      this.identificativoColore = "";
      this.ragioneSocialeColore = "";
      this.indirizzoColore = "";
      this.comuneColore = "";
      this.capColore = "";
      this.provinciaColore = "";
      this.referente1Colore = "";
      this.telefono1Colore = "";
      this.email1Colore = "";
      this.referente2Colore = "";
      this.telefono2Colore = "";
      this.email2Colore = "";
      this.MDMColore = "";
      this.MAMColore = "";
      this.PDPColore = "";
      this.PAPColore = "";
      // normalizzo i campi rimasti null o undefined
      if(this.ragioneSociale === null || this.ragioneSociale === undefined){
        this.ragioneSociale = "";
      }
      if(this.indirizzo === null || this.indirizzo === undefined){
        this.indirizzo = "";
      }
      if(this.comune === null || this.comune === undefined){
        this.comune = "";
      }
      if(this.cap === null || this.cap === undefined){
        this.cap = "";
      }
      if(this.provincia === null || this.provincia === undefined){
        this.provincia = "";
      }
      if(this.referente === null || this.referente === undefined){
        this.referente = "";
      }
      if(this.telefono === null || this.telefono === undefined){
        this.telefono = "";
      }
      if(this.email === null || this.email === undefined){
        this.email = "";
      }
      if(this.referente2 === null || this.referente2 === undefined){
        this.referente2 = "";
      }
      if(this.telefono2 === null || this.telefono2 === undefined){
        this.telefono2 = "";
      }
      if(this.email2 === null || this.email2 === undefined){
        this.email2 = "";
      }
      if(this.MDM === null || this.MDM === undefined){
        this.MDM = "00:00";
      }
      if(this.MAM === null || this.MAM === undefined){
        this.MAM = "00:00";
      }
      if(this.PDP === null || this.PDP === undefined){
        this.PDP = "00:00";
      }
      if(this.PAP === null || this.PAP === undefined){
        this.PAP = "00:00";
      }
      if(this.lunedi === null || this.lunedi === undefined){
        this.lunedi = 1;
      }
      if(this.martedi === null || this.martedi === undefined){
        this.martedi = 1;
      }
      if(this.mercoledi === null || this.mercoledi === undefined){
        this.mercoledi = 1;
      }
      if(this.giovedi === null || this.giovedi === undefined){
        this.giovedi = 1;
      }
      if(this.venerdi === null || this.venerdi === undefined){
        this.venerdi = 1;
      }
      if(this.nazione_selezionata === null || this.nazione_selezionata === undefined){
        this.nazione_selezionata = "I";
      }
      this.Validate();
    },
    CambioFocusLocalita(){
      this.$refs.provincia.focus();
      this.$refs.cap.focus();
    },
    CambioFocusCap(){
      this.$refs.provincia.focus();
      this.$refs.riferimento1.focus();
      this.$refs.provincia.focus();
    },
    ValidaEmail(email){
      if(email === "")
        return true;
      var regexEmail = /^(([^\'<>()\[\]\\.,;:\s@"]+(\.[^\'<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
      var resultMail = email.trim().match(regexEmail);
      if(resultMail === null){
        return false;
      }
      else{
        return true
      }
    },
    CheckMDM(){
      this.ErroreOrario = "";
      var erroreMDM = ""
      var vuoto = false;
      var vuotoMAM = false;
      if(this.MDM === null || this.MDM === "" || this.MDM === "00:00" ){
        erroreMDM += "";
        vuoto = true;
      }
      if(this.MAM === "" || this.MAM === "00:00"){
        vuotoMAM = true;
      }
      var regexNum = /[^0-99]/g;
      var resultMDM = this.MDM.replace(":", "").match(regexNum);
      if(resultMDM != null){
        erroreMDM += "- Non è possibile inserire caratteri non numerici nel campo dell'orario apertura della mattina.<br>";
      }
      if(this.MDM.trim().length != 5 || this.MDM.trim().replaceAll(":", "").length != 4)
        erroreMDM += "- Controllare il formato dell'orario dell'apertura della mattina inserito. Il formato deve seguire la regola: HH:MM. <br>"
      else{
        if(!this.MDM.includes(":"))
          erroreMDM += "- Controllare il formato dell'orario dell'apertura della mattina inserito. Il formato deve seguire la regola: HH:MM. <br>"
        if(this.MDM[2] != ":")
          erroreMDM += "- Controllare il formato dell'orario dell'apertura della mattina inserito. Il formato deve seguire la regola: HH:MM. <br>"
        if(this.MDM.substring(0,2) > this.MAM.substring(0,2))
          erroreMDM += "- Non è possibile indicare un orario successivo a quello di chiusura della mattina.<br>"
        if(Number(this.MDM.substring(0,2)) > 13 || (Number(this.MDM.substring(0,2)) === 13 && Number(this.MDM.substring(3,5)) > 0))
          erroreMDM += "- Non è possibile indicare un orario successivo alle 13:00.<br>"
        if(Number(this.MDM.substring(0,2)) < 6 || (Number(this.MDM.substring(0,2)) === 6 && Number(this.MDM.substring(3,5)) < 30)){
          erroreMDM += "- Non è possibile indicare un orario precedente alle 06:30.<br>"
        }
        if(this.MDM.substring(0,2) == this.MAM.substring(0,2) && Number(this.MDM.substring(3,5)) > Number(this.MAM.substring(3,5)))
          erroreMDM += "- Non è possibile indicare un orario successivo a quello di chiusura della mattina.<br>"
        if(this.MDM == this.MAM)
          erroreMDM += "- Non è possibile indicare un orario uguale a quello di chiusura della mattina.<br>"
        if(Number(this.MDM.substring(3,5)) > 59 )
          erroreMDM += "- Controllare il formato dell'orario dell'apertura della mattina inserito. Il formato deve seguire la regola: HH:MM."
      }
      if(erroreMDM != "" && vuoto === false && vuotoMAM === false){
        this.DialogErroreOrario = true;
        this.ErroreOrario = erroreMDM;
      }
      if(vuoto){
        this.MDM = "00:00";
      }
    },
    CheckMattino(){
      this.ErroreOrarioMattino = "";
      var erroreMAM = "";
      if((this.MAM === null || this.MAM === "" || this.MAM === "00:00") && this.MDM !== "" && this.MDM !== "00:00"){
        erroreMAM += "- Il campo orario chiusura della mattina deve essere valorizzato se valorizzato l'orario di apertura.<br>";
        this.DialogErroreOrarioMAM = true;
        this.ErroreOrarioMattino = erroreMAM;
      }
      else{
        if(this.MAM !== "" && this.MAM !== "00:00" && (this.MDM === "00:00" || this.MDM === "")){
          erroreMAM += "- Il campo orario apertura della mattina deve essere valorizzato se valorizzato l'orario di chiusura.<br>";
          this.DialogErroreOrario = true;
          this.ErroreOrarioMattino = erroreMAM;
        }
      }
    },
    CheckMAM(){
      this.ErroreOrario = "";
      var erroreMAM = "";
      var vuoto = false;
      var vuotoMDM = false;
      if(this.MAM === null || this.MAM === "" || this.MAM === "00:00"){
        erroreMAM += "- Il campo orario chiusura della mattina deve essere valorizzato se valorizzato l'orario di apertura<br>"
        vuoto = true;
        this.MAM = "00:00";
      }
      var regexNum = /[^0-99]/g;
      var resultMAM = this.MAM.replace(":", "").match(regexNum);
      if(resultMAM != null){
        erroreMAM += "- Non è possibile inserire caratteri non numerici nel campo dell'orario chiusura della mattina.<br>";
      }
      if(this.MDM === "" || this.MDM === "00:00"){
        vuotoMDM = true;
      }
      if(this.MAM.trim().length != 5 || this.MAM.trim().replaceAll(":", "").length != 4)
        erroreMAM += "- Controllare il formato dell'orario della  chiusura della mattina inserito. Il formato deve seguire la regola: HH:MM. <br>"
      else{
        if(!this.MAM.includes(":"))
          erroreMAM += "- Controllare il formato dell'orario della  chiusura della mattina inserito. Il formato deve seguire la regola: HH:MM. <br>"
         if(Number(this.MAM.substring(0,2)) > 13 || (Number(this.MAM.substring(0,2)) === 13 && Number(this.MAM.substring(3,5)) > 0))
          erroreMAM += "- Non è possibile indicare un orario successivo alle 13:00.<br>"
        if(Number(this.MAM.substring(0,2)) < 6 || (Number(this.MAM.substring(0,2)) === 6 && Number(this.MAM.substring(3,5)) < 30))
          erroreMAM += "- Non è possibile indicare un orario precedente alle 06:30.<br>"
        if(this.MDM.substring(0,2) > this.MAM.substring(0,2))
          erroreMAM += "- Non è possibile indicare un orario precedente a quello di apertura della mattina.<br>"
        if(this.MDM.substring(0,2) == this.MAM.substring(0,2) && Number(this.MDM.substring(3,5)) > Number(this.MAM.substring(3,5)))
          erroreMAM += "- Non è possibile indicare un orario precedente a quello di apertura della mattina.<br>"
        if(this.MDM == this.MAM)
          erroreMAM += "- Non è possibile indicare un orario uguale a quello di apertura della mattina.<br>"
        if(Number(this.MAM.substring(3,5)) > 59 )
          erroreMAM += "- Controllare il formato dell'orario della chiusura della mattina inserito. Il formato deve seguire la regola: HH:MM."
      }
      if(erroreMAM != "" && vuoto === false && vuotoMDM === false){
        this.DialogErroreOrarioMAM = true;
        this.ErroreOrario = erroreMAM;
      }
      
    },
    CheckPDP(){
      
      this.ErroreOrario = "";
      var errorePDP = "";
      var vuoto = false;
      if(this.PDP === null || this.PDP === "" || this.PDP === "00:00"){
        vuoto = true;
        this.PDP = "00:00";
      }
      if(this.PDP == null || this.PDP == "")
        errorePDP += "- Il campo orario di apertura del pomeriggio deve essere valorizzato <br>"
       var regexNum = /[^0-99]/g;
      var resultPDP = this.PDP.replace(":", "").match(regexNum);
      if(resultPDP != null){
        errorePDP += "- Non è possibile inserire caratteri non numerici nel campo dell'orario apertura del pomeriggio.<br>";
      }
      if(this.PDP.trim().length != 5 || this.PDP.trim().replaceAll(":", "").length != 4)
        errorePDP += "- Controllare il formato dell'orario di apertura del pomeriggio inserito. Il formato deve seguire la regola: HH:MM. <br>"
      else{
        if(!this.PDP.includes(":"))
          errorePDP += "- Controllare il formato dell'orario dell'apertura' del pomeriggio inserito. Il formato deve seguire la regola: HH:MM. <br>"
        if(Number(this.PDP.substring(0,2)) > 19 || (Number(this.PDP.substring(0,2)) === 19 && Number(this.PDP.substring(3,5)) > 30))
          errorePDP += "- Non è possibile indicare un orario successivo alle 19:30.<br>"
        if(Number(this.PDP.substring(0,2)) < 13 || Number(this.PDP.substring(0,2)) === 13 && Number(this.PDP.substring(3,5)) < 1)
          errorePDP += "- Non è possibile indicare un orario precedente alle 13:01.<br>"
        if(this.PDP.substring(0,2) > this.PAP.substring(0,2))
          erroreMDM += "- Non è possibile indicare un orario successivo a quello di chiusura del pomeriggio.<br>"
        if(Number(this.PDP.substring(3,5)) > 59 )
          errorePDP += "- Controllare il formato dell'orario della chiusura del pomeriggio inserito. Il formato deve seguire la regola: HH:MM."
        if(this.PDP == this.PAP)
          errorePDP += "- Non è possibile indicare un orario uguale a quello di chiusura del pomeriggio.<br>"
        if(this.PDP.substring(0,2) > this.PAP.substring(0,2))
          errorePDP += "- Non è possibile indicare un orario successivo a quello di chiusura del pomeriggio.<br>"
        if(this.PDP.substring(0,2) == this.PAP.substring(0,2) && Number(this.PDP.substring(3,5)) > Number(this.PAP.substring(3,5)))
          errorePDP += "- Non è possibile indicare un orario successivo a quello di chiusura del pomeriggio.<br>"
      }
      if(errorePDP != "" && vuoto === false){
        this.DialogErroreOrarioPDP = true;
        this.ErroreOrario = errorePDP;
      }
      

    },
    CheckPAP(){
      this.ErroreOrario = "";
      var errorePAP = ""
      var vuoto = false;
      if(this.PAP === null || this.PAP === "" || this.PAP === "00:00"){
        vuoto = true;
        this.PAP = "00:00";
      }
      if(this.PAP == null || this.PAP == "")
        errorePAP += "- Il campo orario chiusura del pomeriggio deve essere valorizzato <br>"
      var regexNum = /[^0-99]/g;
      var resultPDP = this.PDP.replace(":", "").match(regexNum);
      if(resultPDP != null){
        errorePDP += "- Non è possibile inserire caratteri non numerici nel campo dell'orario apertura del pomeriggio.<br>";
      }
      if(this.PDP.trim().length != 5 || this.PDP.trim().replaceAll(":", "").length != 4)
        errorePAP += "- Controllare il formato dell'orario della chiusura del pomeriggio inserito. Il formato deve seguire la regola: HH:MM. <br>"
      else{
        if(!this.PAP.includes(":"))
          errorePAP += "- Controllare il formato dell'orario della chiusura del pomeriggio inserito. Il formato deve seguire la regola: HH:MM. <br>"
        if(Number(this.PAP.substring(0,2)) > 19 || (Number(this.PAP.substring(0,2)) === 19 && Number(this.PAP.substring(3,5)) > 30))
          errorePAP += "- Non è possibile indicare un orario successivo alle 19:30.<br>"
        if(Number(this.PAP.substring(0,2)) < 13 || Number(this.PAP.substring(0,2)) === 13 && Number(this.PAP.substring(3,5)) < 1)
          errorePAP += "- Non è possibile indicare un orario precedente alle 13:01.<br>"
        if(this.PDP.substring(0,2) == this.PAP.substring(0,2) && Number(this.PDP.substring(3,5)) > Number(this.PAP.substring(3,5)))
          errorePAP += "- Non è possibile indicare un orario precedente a quello di apertura del pomeriggio.<br>"
        if(Number(this.PAP.substring(3,5)) > 59 )
          errorePAP += "- Controllare il formato dell'orario della chiusura del pomeriggio inserito. Il formato deve seguire la regola: HH:MM."
        if(this.PDP == this.PAP)
          errorePAP += "- Non è possibile indicare un orario uguale a quello di apertura del pomeriggio.<br>"
        if(this.PDP.substring(0,2) > this.PAP.substring(0,2))
          errorePAP += "- Non è possibile indicare un orario precedente a quello di apertura del pomeriggio.<br>"
      }
      if(errorePAP != "" && vuoto === false){
        this.DialogErroreOrarioPAP = true;
        this.ErroreOrario = errorePAP;
      }
    },
    isIntegerDate(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 58)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    SelezionaCapparioRitiro(localita, provincia, cap) {
      this.Cappario = false;
      this.comune = localita.trim().replace("''", "'");
      this.provincia = provincia.trim().replace("''", "'");
      this.cap = cap.trim().replace("''", "'");
      this.$refs.provincia.focus();
      this.$refs.riferimento1.focus();
      this.searchCappario = "";
    },
    OpenCappario(cerca) {
      if(cerca !== null && cerca !== undefined){
        if(cerca.trim() !== ""){
          this.overlay = true;
          if (cerca !== "ERRORE") {
            this.searchCappario = cerca.trim();
            axios.get(this.$store.state.servicePath + "/api/ArVwNazionis/" + this.nazione_selezionata + "/" + this.searchCappario).
            then(res =>{
              if(res.data.length === 1){
                this.comune = res.data[0].trploc;
                this.provincia = res.data[0].trpprv;
                this.cap = res.data[0].trpcap;
                this.$refs.provincia.focus();
                this.$refs.riferimento1.focus();
                this.overlay = false;
              }
              else if (res.data.length > 1){
                this.lista_cappario = res.data;
                this.Cappario = true;
                this.overlay = false;
              }
              else{
                this.overlay = false;
              }
            })
            .catch(err=> {
              this.overlay = false;
            });

          } else {
            this.erroreCappario = true;
            this.overlay = false;
          }
        }
        else{
          this.overlay = false;
        }
      }
      else{
        this.overlay = false;
      }

    },
    Valida_Localita(){
      if(this.provincia.length < 2){
        this.ProvinciaValida = false;
      }
      if(this.cap === null)
        this.cap = "";
      if(this.comune === null)
        this.comune = "";
      if(this.cap.length <5 || this.cap.trim().length === 0){
        this.ProvinciaValida = false;
      }
      if(this.comune.trim() === ""){
        this.ProvinciaValida = false;
      }
      else{
         
        axios.get(this.$store.state.servicePath + "/api/ArVwNazionis/ValidaCappario/" + this.nazione_selezionata + "/" + this.comune + "/" + this.cap +"/" + this.provincia)
      .then(res => {
        if(res.data){
          this.ProvinciaValida = true;
        }
        else{
          this.ProvinciaValida = false;
        }
      });
      }
      
    },
    GetNazioni(){
      axios.get(this.$store.state.servicePath + "/api/ArVwNazionis").
            then(res=> {
                res.data.forEach(el=>{
                  var element = {text: el.tbdnaz.trim(), value: el.tbcnaz};
                  this.nazioni.push(element);
                })
      });
    },
    getDataForId() {
      axios
        .get(this.$store.state.servicePath + "/api/ArRubricaClientis/" + this.id)
        .then(res => {
          var estero = res.data.capEstero != null && res.data.capEstero != undefined ? res.data.capEstero : "";
          var naz = res.data.nazione != null && res.data.nazione != undefined ? res.data.nazione : "" ;
          if(naz == null || naz == undefined || naz == "" || naz == " ")
            naz = "I";
          if(estero == null || estero == undefined)
            estero = "";
          //this.codiceAzienda = res.data.codiceAzienda
          this.identificativo = res.data.clientId != null && res.data.clientId != undefined ? res.data.clientId.replace("''", "'"): "";
          this.ragioneSociale = res.data.ragioneSociale != null && res.data.ragioneSociale != undefined ? res.data.ragioneSociale.replace("''", "'") : "";
          this.indirizzo = res.data.indirizzo != null && res.data.indirizzo != undefined ? res.data.indirizzo.replace("''", "'") : "";
          if(estero.trim() == "")
            this.cap = res.data.cap != null && res.data.cap != undefined ? res.data.cap.trim().replace("''", "'") : "";
          else{
            this.cap = res.data.capEstero != null && res.data.capEstero != undefined ? res.data.capEstero : "";
          }
          this.comune = res.data.comune != null && res.data.comune != undefined ? res.data.comune.replace("''", "'") : "";
          this.provincia = res.data.provincia != null && res.data.provincia != undefined ? res.data.provincia.replace("''", "'") : "";
          this.referente = res.data.referente != null && res.data.referente != undefined ? res.data.referente.replace("''", "'") : "";
          this.email = res.data.email != null && res.data.email != undefined ? res.data.email.replace("''", "'") : "";
          this.telefono = res.data.telefono != null && res.data.telefono != undefined ? res.data.telefono.replace("''", "'") : "";
          this.Civico = res.data.numciv != null && res.data.numciv != undefined ? res.data.numciv.replace("''", "'") : "" ;
          if(res.data.oraAperturaMattino !== null && res.data.oraAperturaMattino !== undefined){
            if(res.data.oraAperturaMattino.trim() !== ""){
              this.MDM = res.data.oraAperturaMattino.substr(0,2) + ":" +  res.data.oraAperturaMattino.substr(2,2)
            }
            else{
              this.MDM = "08:00";
            }
          }
          else{
            this.MDM = "08:00";
          }
          if(res.data.oraChiusuraMattino !== null && res.data.oraChiusuraMattino !== undefined){
            if(res.data.oraChiusuraMattino.trim() !== ""){
              this.MAM = res.data.oraChiusuraMattino.substr(0,2) + ":" +  res.data.oraChiusuraMattino.substr(2,2)
            }
            else{
              this.MAM = "13:00";
            }
          }
          else{
            this.MAM = "13:00";
          }
          if(res.data.oraAperturaPomeriggio !== null && res.data.oraAperturaPomeriggio !== undefined){
            if(res.data.oraAperturaPomeriggio.trim() !== ""){
              this.PDP = res.data.oraAperturaPomeriggio.substr(0,2) + ":" +  res.data.oraAperturaPomeriggio.substr(2,2)
            }
            else{
              this.PDP = "13:30";
            }
          }
          else{
            this.PDP = "13:30";
          }
          if(res.data.oraChiusuraPomeriggio !== null && res.data.oraChiusuraPomeriggio !== undefined){
            if(res.data.oraChiusuraPomeriggio.trim() !== ""){
              this.PAP = res.data.oraChiusuraPomeriggio.substr(0,2) + ":" +  res.data.oraChiusuraPomeriggio.substr(2,2)
            }
            else{
              this.PAP = "18:00";
            }
          }
          else{
            this.PAP = "18:00";
          }
          //this.MDM = res.data.oraAperturaMattino != null && res.data.oraAperturaMattino != undefined && res.data.oraAperturaMattino != "" && res.data.oraAperturaMattino != "    "? res.data.oraAperturaMattino.substr(0,2) + ":" +  res.data.oraAperturaMattino.substr(2,2): "";
          //this.MAM = res.data.oraChiusuraMattino != null && res.data.oraChiusuraMattino != undefined && res.data.oraChiusuraMattino != "" && res.data.oraChiusuraMattino != "    " ? res.data.oraChiusuraMattino.substr(0,2) + ":" +  res.data.oraChiusuraMattino.substr(2,2) : "";
          //this.PDP = res.data.oraAperturaPomeriggio != null && res.data.oraAperturaPomeriggio != undefined && res.data.oraAperturaPomeriggio != "" && res.data.oraAperturaPomeriggio != "    " ? res.data.oraAperturaPomeriggio.substr(0,2) + ":" + res.data.oraAperturaPomeriggio.substr(2,2) : "";
          //this.PAP = res.data.oraChiusuraPomeriggio != null && res.data.oraChiusuraPomeriggio != undefined && res.data.oraChiusuraPomeriggio != "" && res.data.oraChiusuraPomeriggio != "    " ? res.data.oraChiusuraPomeriggio.substr(0,2) + ":" + res.data.oraChiusuraPomeriggio.substr(2,2): "";
          this.lunedi = res.data.giorniAperturaSettimanali.substr(0,1) === " "?1:res.data.giorniAperturaSettimanali.substr(0,1) === "M"?2:res.data.giorniAperturaSettimanali.substr(0,1) === "P"?3:4;
          this.martedi = res.data.giorniAperturaSettimanali.substr(1,1) === " "?1:res.data.giorniAperturaSettimanali.substr(1,1) === "M"?2:res.data.giorniAperturaSettimanali.substr(1,1) === "P"?3:4;
          this.mercoledi = res.data.giorniAperturaSettimanali.substr(2,1) === " "?1:res.data.giorniAperturaSettimanali.substr(2,1) === "M"?2:res.data.giorniAperturaSettimanali.substr(2,1) === "P"?3:4;
          this.giovedi = res.data.giorniAperturaSettimanali.substr(3,1) === " "?1:res.data.giorniAperturaSettimanali.substr(3,1) === "M"?2:res.data.giorniAperturaSettimanali.substr(3,1) === "P"?3:4;
          this.venerdi = res.data.giorniAperturaSettimanali.substr(4,1) === " "?1:res.data.giorniAperturaSettimanali.substr(4,1) === "M"?2:res.data.giorniAperturaSettimanali.substr(4,1) === "P"?3:4;
          //this.giorniAperturaSettimanali = res.data.giorniAperturaSettimanali;
          this.referente2 = res.data.referente2 != null && res.data.referente2 != undefined ? res.data.referente2.replace("''", "'") : "";
          this.email2 = res.data.email2 != null && res.data.email2 != undefined ? res.data.email2.replace("''", "'") : "";
          this.telefono2 = res.data.telefono2 != null && res.data.telefono2 != undefined ? res.data.telefono2.replace("''", "'") : "";
          this.nazione = naz;
          this.status = res.data.status;
        })
        .catch(err=> {
          this.erroreConnessione = true;
        });
    },
    submit() {
      this.giorniAperturaSettimanali = "";
      this.giorniAperturaSettimanali += this.lunedi === 1?" ":this.lunedi === 2?"M":this.lunedi === 3?"P":"T";
      this.giorniAperturaSettimanali += this.martedi === 1?" ":this.martedi === 2?"M":this.martedi === 3?"P":"T";
      this.giorniAperturaSettimanali += this.mercoledi === 1?" ":this.mercoledi === 2?"M":this.mercoledi === 3?"P":"T";
      this.giorniAperturaSettimanali += this.giovedi === 1?" ":this.giovedi === 2?"M":this.giovedi === 3?"P":"T";
      this.giorniAperturaSettimanali += this.venerdi === 1?" ":this.venerdi === 2?"M":this.venerdi === 3?"P":"T";
      var iden = "";
      if(this.perIdentificativo === 1 || this.perIdentificativo === "1"){
        iden = this.identificativo;
      }
      this.json = {
          id: this.id,
          clientId: iden,
          ragioneSociale: this.ragioneSociale.replace("'", "''"),
          indirizzo: this.indirizzo.replace("'", "''"),
          numciv: this.Civico.replace("'", "''"),
          cap: this.cap.replace("'", "''"),
          comune: this.comune.replace("'", "''"),
          provincia: this.provincia.replace("'", "''"),
          referente: this.referente.replace("'", "''"),
          email: this.email.replace("'", "''"),
          telefono: this.telefono.replace("'", "''"),
          oraAperturaMattino: this.MDM.replace(":", ""),
          oraChiusuraMattino: this.MAM.replace(":", ""),
          oraAperturaPomeriggio: this.PDP.replace(":", ""),
          oraChiusuraPomeriggio: this.PAP.replace(":", ""),
          giorniAperturaSettimanali: this.giorniAperturaSettimanali,
          referente2 : this.referente2.replace("'", "''"),
          email2: this.email2.replace("'", "''"),
          telefono2: this.telefono2.replace("'", "''"),
          nazione: this.nazione_selezionata,
          status: this.status
      }
      if (this.update) {
        this.UpdateData();
      } else {
        this.InsertData();
      }
    },
    UpdateData() {
      axios
        .put(this.$store.state.servicePath + "/api/ArRubricaClientis/", this.json)
        .then(res => {
          if (res.data.id !== 0) {
            this.$router.push({ path: `/NuovaRubrica` });
          }
          
        })
        .catch(err=>{
          this.erroreConnessione = true;
        }

        );
    },
    InsertData() {
      axios.post(this.$store.state.servicePath + "/api/ArRubricaClientis/ControllaDuplicati", this.json)
      .then(res =>{
        if(res.data){
          this.duplicato = true;
        }
        else{
          this.InserisciNuovo();
        }
      })
      .catch(err=>{
          this.erroreConnessione = true;
        })
    },
    InserisciNuovo(){
      axios
        .post(this.$store.state.servicePath + "/api/ArRubricaClientis/", this.json)
        .then(res => {
          if (res.data.id !== 0) {
            this.$router.push({ path: `/NuovaRubrica` });
          }
          })
        .catch(err=>{
          this.erroreConnessione = true;
        }

        );
    },
    clear() {
      this.identificativo = "";
      this.identificativoColore = "";
      this.ragioneSocialeColore = "";
      this.indirizzoColore = "";
      this.comuneColore = "";
      this.capColore = "";
      this.provinciaColore = "";
      this.referente1Colore = "";
      this.telefono1Colore = "";
      this.email1Colore = "";
      this.referente2Colore = "";
      this.telefono2Colore = "";
      this.email2Colore = "";
      this.MDMColore = "";
      this.MAMColore = "";
      this.PDPColore = "";
      this.PAPColore = "";
      this.erroreValidazione = false;
      this.Errore = "";
      this.valid = true;
      this.ErroreOrario = "";
      this.ErroreOrarioMattino = "";
      this.DialogErroreOrario = false;
      this.DialogErroreOrarioMAM = false;
      this.DialogErroreOrarioPAP = false;
      this.DialogErroreOrarioPDP = false;
      this.ProvinciaValida = true;
      this.nazione = {value: "I"};
      this.nazione_selezionata = "I";
      this.lunedi = 1;
      this.martedi = 1;
      this.mercoledi = 1;
      this.giovedi = 1;
      this.venerdi = 1;
      this.clientId = "";
      this.referente2 = "";
      this.email2 = "";
      this.telefono2 = "";
      this.codiceAzienda = "";
      this.ragioneSociale = "";
      this.indirizzo = "";
      this.cap = "";
      this.comune = "";
      this.provincia = "";
      this.referente = "";
      this.email = "";
      this.telefono = "";
      this.MDM = "08:00";
      this.MAM = "13:00";
      this.PDP = "13:30";
      this.PAP = "18:00";
      this.giorniAperturaSettimanali = "";
      this.id = 0;
      this.update = false;
      this.Cappario = false;
      this.searchCappario = "";
      this.overlay = false;
      this.lista_cappario = [];
      this.json = {};
    },
    CheckJWT() {
      axios
        .post(this.$store.state.servicePath + "/api/Login/checkJwt", {
          route: this.$route.path
        })
        .then(res => {
          if (res.data.status == "ko") {
            this.$router.push({ path: `/errore` });
          }
        })
        .catch(err =>{
          this.$router.push({ path: `/errore` });
        });
    },
    CalcolaGiorniChiusura(giorno){
      if(giorno === 1){
        return " ";
      }
      else if(giorno === 2){
        return "M";
      }
      else if(giorno === 3){
        return "P";
      }
      else if(giorno === 4){
        return "T";
      }
    },
  },
  watch: {
    nazione: function(value){
      this.nazione_selezionata = value;
    },
    ragioneSociale: function(value){
      this.ragioneSociale = value.replace(" -- ", " - ");
      this.ragioneSociale = this.ragioneSociale.toUpperCase();
    },
    indirizzo: function(value){
      this.indirizzo = value.replace(" -- ", " - ");
      this.indirizzo = this.indirizzo.toUpperCase();
    },
    comune: function(value){
      this.comune = value.replace(" -- ", " - ");
      this.comune = this.comune.toUpperCase();
    },
    cap: function(value){
      this.cap = value.toUpperCase();
    },
    provincia: function(value){
      this.provincia = value.toUpperCase();
    },
    referente: function(value){
      this.referente = value.toUpperCase();
    },
    telefono: function(value){
      this.telefono = value.toUpperCase();
    },
    email: function(value){
      this.email = value.toUpperCase();
    },
    referente2: function(value){
      this.referente2 = value.toUpperCase();
    },
    telefono2: function(value){
      this.telefono2 = value.toUpperCase();
    },
    email2: function(value){
      this.email2 = value.toUpperCase();
    },
    MDM: function(value){
      if(value.length == 2)
        this.MDM = value + ":";
    },
    MAM: function(value){
      if(value.length == 2)
        this.MAM = value + ":";
    },
    PAP: function(value){
      if(value.length == 2)
        this.PAP = value + ":";
    },
    PDP: function(value){
      if(value.length == 2)
        this.PDP = value + ":";
    },
  }
};
</script>